
export default {
    configuration: true,
    'searchList': {
        'searchTxt': [
            {
                'name': '服务平台',
                'value': 'siteName',
                'unfold': true,
                'advanceConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                    { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
                ],
                'tableConfig': [
                    { 'prop': 'escoCompanyNo', 'value': '服务平台编码' },
                    { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' }
                ],
                'advanceUrl': '/searchPlatform',
                'type': 'advance',
                'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                'span': 4
            },
            {
                'name': '请选择 省 / 市 / 区',
                'value': 'addressCode',
                'config': {
                    'checkStrictly': true
                },
                'type': 'addressCascader',
                'unfold': true,
                'minLayers': 1,
                'span': 5
            },
            {
                'name': '状态',
                'value': 'limitStatus',
                'type': 'select',
                'options': [
                    { 'label': '启用', 'value': '0' },
                    { 'label': '停用', 'value': '1' }
                ],
                'unfold': true,
                'span': 3
            }
        ],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table': {
        'clickModify': true,
        'selectBtn': true,
        'leftWidth': 140,
        'height': '400px',
        'leftOperation': true,
        'columns': [
            {
                'label': '状态',
                'prop': 'limitStatusName',
                'width': 100,
                'sort': true
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'width': 100,
                'sort': true
            },
            {
                'label': '省份',
                'prop': 'provinceName',
                'width': 140,
                'sort': true
            },
            {
                'label': '城市',
                'prop': 'cityName',
                'width': 120,
                'sort': true
            },
            {
                'label': '区县',
                'prop': 'districtName',
                'width': 120,
                'sort': true
            },
            {
                'label': '乡镇',
                'prop': 'townName',
                'width': 120,
                'sort': true
            },
            {
                'label': '最大可用车型',
                'prop': 'maximumEquipmentName',
                'width': 140,
                'sort': true
            },
            {
                'label': '成本系数',
                'prop': 'costCoefficient',
                'width': 120,
                'sort': true
            },
            {
                'label': '区域分类',
                'prop': 'areaClassify',
                'width': 120,
                'sort': true
            },
            {
                'label': '备注',
                'prop': 'remark',
                'width': 140,
                'sort': true
            },
            {
                'label': '修改人',
                'prop': 'updateUserName',
                'width': 100,
                'sort': true
            },
            {
                'label': '修改时间',
                'prop': 'updateTime',
                'width': 140,
                'sort': true
            }
        ],
        'action': [
            {
                'type': 'text',
                'label': '编辑',
                'size': 'small',
                'event': 'edit',
                'ifHas': '11070005'
            },
            {
                'type': 'text',
                'label': '启用',
                'size': 'small',
                'event': 'enable',
                'ifHas': '11070006'
            },
            {
                'type': 'text',
                'label': '停用',
                'size': 'small',
                'event': 'disable',
                'ifHas': '11070007'
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 10,
        'pageSizes': [
            10,
            20,
            30,
            50
        ]
    },
    'ImportConfig': {
        'action': `${process.env.VUE_APP_API_URL || ''}/api-tms/baseLimitAreas/import`,
        'multiple': false,
        'accept': 'xlsx/text',
        'showFileList': true,
        'fileType': '只能上传Excel文件',
        'manualUpload': false
    },
    'ImportContent': [{
        'fileName': '限行区域_导入.xlsx',
        'fileSize': '9.4KB',
        'downLoadInfo': {
            'url': ``
        }
    }]
};
